import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["name", "path"];
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createInstance, Identify } from '@amplitude/analytics-browser';
import { isNewSession } from '@amplitude/analytics-client-common';
import ahoy from 'ahoy.js';
import { linkedinConversions } from './3rd-party/linkedin/conversion_ids';
import { detectChannel } from '~/components/utils/traffic_channel';
import { transformObjectKeys } from '~/components/utils/core/object';
var AMPLITUDE_ID_DEVELOPMENT = '0ba7dc92c79c9645cef2dbeed059b4bd';
var AMPLITUDE_ID_PRODUCTION = 'e508b97e32f23f43e3fb1c9087d5b7d8';
var currentABTestName = '';
var amplitude = createInstance();
var amplitudeDefaultSessionTimeout = 30 * 60 * 1000;
var AMPLITUDE_ID = process.env.isProduction ? AMPLITUDE_ID_PRODUCTION : AMPLITUDE_ID_DEVELOPMENT;
var b2cSignUp = linkedinConversions.b2cSignUp;
var getProps = function getProps(ctx, currentProps) {
  var props = _objectSpread(_objectSpread({}, currentProps), {}, {
    route_name: ctx.route.name,
    pathname: ctx.route.path,
    from_web: true
  });
  var ab_test = ctx.store.state.auth.loggedIn && JSON.parse(JSON.stringify(ctx.store.state.auth.user.abTests));
  if (ab_test) {
    props.ab_test = transformObjectKeys(function (key) {
      return key.replace(/^ab-test-/, '');
    })(ab_test);
  }
  Object.entries(ctx.$ab.getAll()).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    props.ab_test = props.ab_test || {};
    props.ab_test[key] = value;
  });
  return props;
};
var AHOY_CONFIG = {
  visitsUrl: "/bucket/apples",
  eventsUrl: "/bucket/oranges",
  visitParams: {
    traffic_channel: detectChannel()
  },
  visitDuration: 30
};
ahoy.configure(AHOY_CONFIG);
export default (function (ctx, inject) {
  var _ctx$store$state$auth, _ctx$store$state$auth2, _ctx$app$store;
  var isAdmin = ((_ctx$store$state$auth = ctx.store.state.auth.user) === null || _ctx$store$state$auth === void 0 ? void 0 : _ctx$store$state$auth.admin) || ((_ctx$store$state$auth2 = ctx.store.state.auth.user) === null || _ctx$store$state$auth2 === void 0 ? void 0 : _ctx$store$state$auth2.isImpersonateMode);
  var analyticsEnabled = process.env.NUXT_ANALYTICAL_TRACKING === 'true' && (!isAdmin || !process.env.isProduction);
  function setAmplitudeUserProperties(props) {
    if (analyticsEnabled) {
      var identify = new Identify();
      for (var _i = 0, _Object$entries = Object.entries(props || {}); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        identify.set(key, value);
      }
      amplitude.identify(identify);
    }
  }
  if (analyticsEnabled) {
    var userId = ctx.store.state.auth.loggedIn ? ctx.store.state.auth.user.id : null;
    amplitude.init(AMPLITUDE_ID, userId, {
      minIdLength: 2,
      autocapture: {
        elementInteractions: true
      }
    });
    if (isNewSession(amplitudeDefaultSessionTimeout)) {
      setAmplitudeUserProperties({
        traffic_channel: detectChannel()
      });
    }
  }
  if (ctx.store.state.auth.loggedIn && ctx.store.state.shouldSyncAmplitudeUserProperties) {
    if (!currentABTestName) return;
    var userABTestPropName = currentABTestName.replace(/^ab-test-(\d)/, 'ab_user__$1');
    setAmplitudeUserProperties(_defineProperty({}, userABTestPropName, ctx.store.state.auth.user.abTests[currentABTestName]));
  }
  var metadata = {};
  var setMetadata = function setMetadata(newMetaData) {
    return metadata = newMetaData;
  };
  var clearMetaData = function clearMetaData() {
    return metadata = {};
  };
  function logAdsEvent(name, props) {
    var eventsMap = {
      'global__user__sign-up': 'Subscribe',
      'global__skwSlug__email-apply': 'Lead',
      onboarding__finish: 'CompleteRegistration'
    };
    if (eventsMap[name]) {
      eventsMap[name] === 'Lead' ? ctx.$3rdParty.tiktok.track('SubmitForm', props) : ctx.$3rdParty.tiktok.track(eventsMap[name], props);
      ctx.$3rdParty.facebook('track', eventsMap[name], _objectSpread(_objectSpread({}, props), {}, {
        email: ctx.store.state.auth.user.email
      }));
    }
  }
  function logEvent(name, props, cb) {
    var newProps = getProps(ctx, props);
    console.info('Event:', name, newProps, cb);
    ahoy.track(name, newProps);
    ctx.$gtag.event(name, newProps);
    if (analyticsEnabled) {
      if (isNewSession(amplitudeDefaultSessionTimeout)) {
        setAmplitudeUserProperties({
          traffic_channel: detectChannel()
        });
      }
      amplitude.track(name, newProps).promise.then(cb);
      logAdsEvent(name, newProps);
    }
  }
  var logAhoyEvent = function logAhoyEvent(name, props) {
    var newProps = getProps(ctx, props);
    ahoy.track(name, newProps);
  };
  function logSignUp(type) {
    var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var amplitudeUser = arguments.length > 2 ? arguments[2] : undefined;
    if (analyticsEnabled) {
      try {
        setAmplitudeUserProperties(amplitudeUser);
      } catch (e) {
        ctx.app.$sentryUtils.error(e, "[analytics]: pixel hasn't loaded for sign up event");
      }
    }
    ctx.$3rdParty.linkedin('track', {
      conversion_id: b2cSignUp
    });
    logEvent('global__user__sign-up', _objectSpread({
      type: type
    }, additionalData));
  }
  function logPageView() {
    var _ctx$from;
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref3.name,
      path = _ref3.path,
      rest = _objectWithoutProperties(_ref3, _excluded);
    var params = _objectSpread(_objectSpread({
      from_route_name: (_ctx$from = ctx.from) === null || _ctx$from === void 0 ? void 0 : _ctx$from.name,
      route_name: name,
      pathname: path,
      location: window.location.href
    }, rest), metadata);
    logEvent('global__page__view', params);
    clearMetaData();
  }
  function setUser(user, oldUser) {
    var userId = user && user.id || null;
    var oldUserId = oldUser && oldUser.id || null;
    if (analyticsEnabled && userId) {
      amplitude.setUserId(userId);
      ctx.$gtag.set({
        user_id: userId
      });
    }
    if (oldUserId !== userId && !userId) {
      amplitude.reset();
      ctx.$gtag.set({
        user_id: null
      });
    }
  }

  // Send all events before hide/close
  // https://www.docs.developers.amplitude.com/data/sdks/typescript-browser/migration/#flush-or-onexitpage
  if (process.client) {
    window.addEventListener('pagehide', function () {
      amplitude.setTransport('beacon');
      amplitude.flush();
    });
  }
  (_ctx$app$store = ctx.app.store) === null || _ctx$app$store === void 0 ? void 0 : _ctx$app$store.watch(function (store) {
    return store.auth.user;
  }, setUser, {
    immediate: true
  });
  inject('analytics', {
    logEvent: logEvent,
    logAhoyEvent: logAhoyEvent,
    logSignUp: logSignUp,
    logPageView: logPageView,
    setUser: setUser,
    setAmplitudeUserProperties: setAmplitudeUserProperties,
    setMetadata: setMetadata,
    clearMetaData: clearMetaData
  });
});